<template>
  <v-card class="card-border" elevation="0">
    <v-card-title class="pb-0 card-title-variations">Produto vinculado</v-card-title>
    <v-card-text class="pb-0">
      <v-row>
        <v-col v-if="isCreate" cols="12">
          <div v-if="productForms.product && !productForms.product.name.length">
            <product-store-add-product v-model="productForms" />
            <div v-if="productError" class="pt-1 error--text v-messages">
              <span class="v-messages__message">Adicione um produto</span>
            </div>
          </div>
          <v-row v-else>
            <v-col class="pt-0" cols="12">
              <div class="d-flex align-center">
                <span v-if="productForms.ecommerceId.length" class="mr-2 detail-text">{{ productForms.ecommerceId }} | </span>
                <span class="ml-2 detail-text">{{ productForms.product.name ? productForms.product.name : '' }}</span>
                <div class="mx-6 card-border img-size">
                  <div class="img-container pa-1 d-flex justify-center align-center">
                    <v-img v-if="validImage" :src="productForms.product.images[0].url" max-height="40" max-width="40" />
                    <mf-icon v-else color="cinza-0"> image </mf-icon>
                  </div>
                </div>
                <product-store-add-product v-model="productForms" />
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="!isCreate" class="pt-0" cols="8">
          <div class="d-flex align-center">
            <span class="mr-2 detail-text">{{ productForms.ecommerceId }} | </span>
            <span class="mx-2 detail-text">{{ productForms.product.name ? productForms.product.name : '' }}</span>
            <div class="card-border img-size">
              <div class="pa-1 d-flex justify-center align-center">
                <v-img
                  v-if="productForms.product && productForms.product.images && productForms.product.images.length"
                  :src="productForms.product.images[0].url"
                  max-height="40"
                  max-width="40"
                />
                <mf-icon v-else color="cinza-0"> image </mf-icon>
              </div>
            </div>
          </div>
        </v-col>
        <v-col v-if="!isCreate" class="pt-0 d-flex justify-end align-center" cols="4">
          <mf-button text color="marca-0-l40" label="Ver página do Produto" icon="arrow_right_alt" icon-position="right" @click="openProduct()" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductStoreAddProduct from './ProductStoreAddProduct.vue'

export default {
  name: 'ProductStoreDetail',
  components: {
    ProductStoreAddProduct,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    validImage() {
      return this.productForms?.product && this.productForms?.product?.images[0]?.url && this.productForms?.product?.images.length
    },
    productError() {
      return this.validation.product.product && this.validation.product.product.$error
    },
  },
  watch: {},
  mounted() {},
  methods: {
    openProduct() {
      const { productId } = this.productForms
      this.$router.push({ path: `/produtos/alterar/${productId}` })
    },
  },
}
</script>

<style lang="scss">
.detail-text {
  font-weight: 400;
  font-size: 22px;
  color: $cinza-d10;
}
.img-size {
  width: 50px;
  height: 50px;
}
.img-container {
  height: 100%;
  width: 100%;
}
.card-border {
  border: 1px solid $cinza-l60 !important;
  border-radius: 4px;
}
.icon-color {
  color: $marca-0-l40 !important;
  text-decoration: none !important;
}
</style>
